import {ComponentType, ReactNode} from 'react';

import {view} from '@sail/ui';

import {AssistantContainer} from '@stripe-internal/conversations-assistant';

import {MobileDevHeader} from './MobileDevHeader';

export function MobileAssistantContainer({
  errorBoundary,
  children,
}: {
  errorBoundary?: ComponentType<{children: ReactNode}> | null;
  children: ReactNode;
}) {
  return (
    <view.div css={{height: '100vh'}}>
      <AssistantContainer
        header={<MobileDevHeader />}
        errorBoundary={errorBoundary}
        footer={null}
      >
        {children}
      </AssistantContainer>
    </view.div>
  );
}
